import { render, staticRenderFns } from "./PackMaterial.vue?vue&type=template&id=728b112d&scoped=true&"
import script from "./PackMaterial.vue?vue&type=script&lang=js&"
export * from "./PackMaterial.vue?vue&type=script&lang=js&"
import style0 from "./PackMaterial.vue?vue&type=style&index=0&id=728b112d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728b112d",
  null
  
)

export default component.exports